var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{attrs:{"type":"text","placeholder":_vm.placeholder,"required":_vm.required === false ? false : true},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input',{value: $event.target.value})}}})])}
var staticRenderFns = []

export { render, staticRenderFns }